module.exports = __webpack_public_path__ + "static/media/logo_2.7922e509.svg";